<template lang="pug">
  .component-driver-card
    .action-bar
      .title
        h2 Driver Tocs
    base-list(:component="component", :dataLoader="dataLoader")

</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import Card from "components/backoffice/Card";
  import CreateCard from "components/structure/ui/CreateCard";
  import BaseList from "../../../pages/backoffice/BaseList";
  import SelectizeCard from "../../structure/ui/lists/selectize/SelectizeCard";
  import MaggieHelper from "../../../maggieHelper";

  export default {
    name: "DriverCards",
    components: {
      SelectizeCard,
      BaseList,
      CreateCard,
      Card,
    },
    data() {
      return {
        component: require('components/backoffice/DriverToc'),
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback) {
        var tocs = {
          current_page: 1,
          current_page_count: 1,
          items: [],
          items_count: 10,
          page_count: 1,
          per_page_count: 25,
        }
        KeplerBackofficeSdk.drivers.select(this.$route.params.id).tocs((data) => {

          tocs.items = data
          tocs.items_count = data.length
          callback(tocs)
        })
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  //.driver-licenses
    margin: 10px
  .component-driver-card
    #create-card
      border: 1px solid #e6e6e6
      background: #fefefe
      padding: 1em 1em 0
      margin-bottom: 2em
      border-radius: 4px
</style>



// WEBPACK FOOTER //
// DriverTocs.vue?045de534